import React, { FC } from 'react';
import { BUTTON_TYPE, ButtonComponent } from './ButtonComponent';
import clsx from 'clsx';

interface Props {
  containerAdditionalClasses?: string,
  cancelBtnAdditionalClasses?: string,
  confirmBtnAdditionalClasses?: string,
  cancelBtnName?: string,
  confirmBtnName?: string,
  onCancel: () => void,
  onConfirm?: () => void,
  buttonType?: 'button' | 'submit' | 'reset',
  isConfirmBtnLoading?: boolean
}
export const ModalManagementButtons: FC<Props> = (props) => {
  const {
    containerAdditionalClasses,
    cancelBtnAdditionalClasses,
    confirmBtnAdditionalClasses,
    cancelBtnName = 'Cancel',
    confirmBtnName = 'Confirm',
    onCancel,
    onConfirm,
    buttonType = 'submit',
    isConfirmBtnLoading = false,
  } = props;
  return (
    <div className={clsx('text-center', containerAdditionalClasses)}>
      <ButtonComponent
        buttonName={cancelBtnName}
        buttonType={BUTTON_TYPE.CANCELLED}
        additionalClass={clsx('btn-sm', cancelBtnAdditionalClasses)}
        onButtonClick={onCancel}
      />
      <ButtonComponent
        buttonName={confirmBtnName}
        type={buttonType}
        additionalClass={clsx('btn-sm ms-10', confirmBtnAdditionalClasses ? confirmBtnAdditionalClasses : 'w-100px')}
        onButtonClick={onConfirm}
        loading={isConfirmBtnLoading}
      />
    </div>
  );
};